import { jsx as _jsx } from "react/jsx-runtime";
import { Logo } from "@vfit/ui/icons";
import { useDeviceType } from "@vfit/shared/hooks";
import { WrapperHeaderLite, MainContainerLite, LogoWrapperLite, WrapperContainerLite, MainContainer, LogoWrapper } from "./HeaderLite.style";
var HeaderLite = function(param) {
    var isLite = param.isLite, _pt = param.pt, pt = _pt === void 0 ? 0 : _pt, _disablePaddingTop = param.disablePaddingTop, disablePaddingTop = _disablePaddingTop === void 0 ? false : _disablePaddingTop, _isMva = param.isMva, isMva = _isMva === void 0 ? false : _isMva;
    var ref = useDeviceType(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    if (isMva) {
        return /*#__PURE__*/ _jsx(MainContainer, {
            id: "header-lite",
            children: /*#__PURE__*/ _jsx(LogoWrapper, {
                children: /*#__PURE__*/ _jsx(Logo, {})
            })
        });
    }
    return /*#__PURE__*/ _jsx(WrapperContainerLite, {
        disablePaddingTop: disablePaddingTop,
        pt: pt,
        className: "headerLite",
        id: "header-lite",
        children: /*#__PURE__*/ _jsx(WrapperHeaderLite, {
            children: /*#__PURE__*/ _jsx(MainContainerLite, {
                isLite: isLite,
                children: /*#__PURE__*/ _jsx(LogoWrapperLite, {
                    isMobile: isMobile,
                    isTablet: isTablet,
                    children: /*#__PURE__*/ _jsx(Logo, {})
                })
            })
        })
    });
};
export default HeaderLite;
